import React, { useState, useEffect } from "react";
import axios from "axios";
import Youtubeapi from "./youtubeapi";

const CLIENT_ID =
  "27064908213-sar1c6pb49flaf563qregab02ndshqfa.apps.googleusercontent.com"; // Replace with your OAuth Client ID
const API_KEY = "AIzaSyAbgB90PHtmcsRuYibqmir30qt70zR6kG0"; // Replace with your YouTube API Key
const REDIRECT_URI = "http://localhost:3000/";
const SCOPES =
  "https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/yt-analytics.readonly";


  const Youtube = () => {
  const [token, setToken] = useState(null);
  const [channelData, setChannelData] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [videos, setVideos] = useState([]);

  // ✅ Login & Fetch Token with Refresh Capability
  const login = () => {
    let tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES, // ✅ Corrected Scope
      prompt: "consent", // ✅ Ensure user consent
      callback: (response) => {
        if (response.access_token) {
          setToken(response.access_token);
          localStorage.setItem("yt_token", response.access_token);
          fetchAllData(response.access_token);
        }
      },
    });
    tokenClient.requestAccessToken({ prompt: "consent" });
  };

  // ✅ Fetch Channel Data
  const fetchChannelData = async (accessToken) => {
    try {
      const response = await axios.get(
        "https://www.googleapis.com/youtube/v3/channels",
        {
          headers: { Authorization: `Bearer ${accessToken}` },
          params: { part: "snippet,statistics", mine: true },
        }
      );
      console.log("Channel Data:", response.data.items[0]);
      setChannelData(response.data.items[0]);
    } catch (error) {
      console.error("Error fetching channel data:", error);
    }
  };

  // ✅ Fetch YouTube Analytics
  const fetchAnalytics = async (accessToken) => {
    try {
      const response = await axios.get(
        "https://youtubeanalytics.googleapis.com/v2/reports",
        {
          headers: { Authorization: `Bearer ${accessToken}` },
          params: {
            ids: "channel==MINE",
            metrics:
              "views,estimatedMinutesWatched,averageViewDuration,subscribersGained,likes,dislikes,comments,shares,annotationClickThroughRate,annotationCloseRate,cardClickRate,cardTeaserClickRate",
            startDate: "2000-01-01", // Start date set to a very early date
            endDate: "2024-03-01", // End date set to current or desired date
          },
        }
      );

      console.log("Analytics Data:", response.data);
      setAnalytics(response.data);
    } catch (error) {
      console.error("Error fetching analytics:", error);
    }
  };

  // ✅ Fetch All Videos from the Channel
  const fetchVideos = async (accessToken) => {
    try {
      const response = await axios.get(
        "https://www.googleapis.com/youtube/v3/search",
        {
          headers: { Authorization: `Bearer ${accessToken}` },
          params: {
            part: "snippet",
            channelId: channelData?.id, // Fetch videos only for authenticated channel
            maxResults: 10,
            order: "date",
          },
        }
      );

      const videoIds = response.data.items
        .map((video) => video.id.videoId)
        .join(",");

      // Fetch video analytics for the retrieved videos
      const analyticsResponse = await axios.get(
        "https://youtubeanalytics.googleapis.com/v2/reports",
        {
          headers: { Authorization: `Bearer ${accessToken}` },
          params: {
            ids: "channel==MINE",
            metrics:
              "views,likes,dislikes,comments,estimatedMinutesWatched,averageViewDuration,shares",
            dimensions: "video",
            filters: `video==${videoIds}`,
            startDate: "2000-01-01",
            endDate: "2024-03-01",
          },
        }
      );

      const analyticsData = analyticsResponse.data.rows.reduce((acc, row) => {
        acc[row[0]] = {
          views: row[1],
          likes: row[2],
          dislikes: row[3],
          comments: row[4],
        };
        return acc;
      }, {});

      const videosWithAnalytics = response.data.items.map((video) => ({
        ...video,
        analytics: analyticsData[video.id.videoId] || {},
      }));

      console.log("Videos Data:", videosWithAnalytics);
      setVideos(videosWithAnalytics);
    } catch (error) {
      console.error("Error fetching videos or video analytics:", error);
    }
  };


  function extractShortsVideoId(url) {
    try {
      const parsed = new URL(url);
      const path = parsed.pathname;
      if (path.startsWith("/shorts/")) {
        return path.split("/shorts/")[1].split("/")[0];
      }
      return null;
    } catch (error) {
      console.error("Invalid URL:", error.message);
      return null;
    }
  }
  
  const fetchVideoData = async () => {
    // Fetch data from API

    const url = "https://youtube.com/shorts/QvzA9stILqQ?si=qar7wRZ1dyzp3xhu"; // Replace with actual URL

    // Extract the video ID from the URL
     const VIDEO_ID = extractShortsVideoId(url); // Use the function to extract the video ID
    console.log("Video ID:", VIDEO_ID); // Log the extracted video ID

    // YouTube Data API v3 Endpoint
    const URL = `https://www.googleapis.com/youtube/v3/videos?part=snippet,statistics&id=${VIDEO_ID}&key=${API_KEY}`;

    await fetch(URL)
      .then((response) => response.json())
      .then((data) => {
        if (data.items && data.items.length > 0) {
          const videoData = data.items[0];
            console.log("Video Data yaha:", videoData);  
          // Extracting relevant information
          const title = videoData.snippet.title;
          const channelTitle = videoData.snippet.channelTitle;
          const publishedAt = videoData.snippet.publishedAt;
          const views = videoData.statistics.viewCount || "N/A";
          const likes = videoData.statistics.likeCount || "N/A";
          const comments = videoData.statistics.commentCount || "N/A";

          console.log("Data", data);

          console.log(`📹 Video Title: ${title}`);
          console.log(`👤 Channel: ${channelTitle}`);
          console.log(`📅 Published: ${publishedAt}`);
          console.log(`👀 Views: ${views}`);
          console.log(`👍 Likes: ${likes}`);
          console.log(`💬 Comments: ${comments}`);
        } else {
          console.log("❌ Video not found or API limit exceeded.");
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  // ✅ Fetch All Data After Login
  const fetchAllData = async (accessToken) => {
    await fetchChannelData(accessToken);
    await fetchAnalytics(accessToken);
    await fetchVideoData();
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("yt_token");
    if (storedToken) {
      setToken(storedToken);
      fetchAllData(storedToken);
    }
  }, []);

  // ✅ Fetch videos after channel data is loaded
  useEffect(() => {
    if (channelData && token) {
      fetchVideos(token);
    }
  }, [channelData, token]);




  return (

    <>
      
    <Youtubeapi/>


      <div className="h-screen w-full bg-gray-100 flex flex-col items-center justify-center">
        <h1 className="text-2xl font-bold mb-4">
          YouTube Channel & Video Analytics
        </h1>

        {!token ? (
          <div>
            <button
              onClick={login}
              className="px-4 py-2 bg-blue-500 text-white text-center rounded-md"
            >
              Login with Google
            </button>
          </div>
        ) : (
          <>
            {/* Channel Data */}
            {channelData && (
              <div className="bg-white p-4 rounded-md shadow-md mb-4">
                <h2 className="font-semibold text-lg">📺 Channel Info</h2>
                <p>👤 Name: {channelData.snippet.title}</p>
                <p>📅 Created: {channelData.snippet.publishedAt}</p>
                <p>👀 Views: {channelData.statistics.viewCount}</p>
                <p>📹 Videos: {channelData.statistics.videoCount}</p>
                <p>👥 Subscribers: {channelData.statistics.subscriberCount}</p>
              </div>
            )}

            {/* Channel Analytics */}
            {analytics && (
              <div className="bg-white p-4 rounded-md shadow-md mb-4">
                <h2 className="font-semibold text-lg">📊 Channel Analytics</h2>
                <p>👀 Views: {analytics.rows[0][0]}</p>
                <p>⏳ Watch Time: {analytics.rows[0][1]} mins</p>
                <p>⌛ Avg View Duration: {analytics.rows[0][2]} secs</p>
                <p>📈 Subscribers Gained: {analytics.rows[0][3]}</p>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Youtube;
